import React, { useEffect, useState } from 'react';
import { ref, onValue, update, off } from 'firebase/database';
import { db } from '../firebase';

const GENRES_DATA = [
  { id: 'A', name: '消化管', sections: ['A01','A02','A03','A04','A05','A06','A07'] },
  { id: 'B', name: '肝胆膵', sections: ['B01','B02','B03','B04','B05','B06','B07','B08','B09','B10'] },
  { id: 'C', name: '循環器', sections: ['C01','C02','C03','C04','C05','C06','C07','C08','C09','C10','C11','C12'] },
  { id: 'D', name: '内分泌・代謝', sections: ['D01','D02','D03','D04','D05','D06','D07','D08','D09'] },
  { id: 'E', name: '腎・泌尿器', sections: ['E01','E02','E03','E04','E05','E06','E07','E08'] },
  { id: 'F', name: '免疫・膠原病', sections: ['F01','F02','F03','F04'] },
  { id: 'G', name: '血液', sections: ['G01','G02','G03','G04','G05','G06','G07'] },
  { id: 'H', name: '感染症', sections: ['H01','H02','H03','H04','H05','H06','H07','H08','H09','H10','H11','H12','H13','H14','H15'] },
  { id: 'I', name: '呼吸器', sections: ['I01','I02','I03','I04','I05','I06','I07','I08','I09','I10'] },
  { id: 'J', name: '神経', sections: ['J01','J02','J03','J04','J05','J06','J07','J08','J09','J10','J11','J12'] },
  { id: 'KL', name: '救急・中毒', sections: ['KL01','KL02','KL03','KL04','KL05','KL06','KL07','KL08'] },
  { id: 'L', name: '輸液', sections: ['L01','L02','L03'] },
  { id: 'M', name: '麻酔', sections: ['M01','M02','M03'] },
  { id: 'O', name: '小児科', sections: ['O01','O02','O03','O04','O05','O06','O07','O08','O09'] },
  { id: 'P', name: '乳腺', sections: ['P01','P02'] },
  { id: 'PQ', name: '産婦人科', sections: ['PQ01','PQ02','PQ03','PQ04','PQ05','PQ06','PQ07','PQ08','PQ09','PQ10','PQ11','PQ12','PQ13'] },
  { id: 'R', name: '眼科', sections: ['R01','R02','R03','R04','R05','R06','R07','R08','R09','R10'] },
  { id: 'S', name: '耳鼻咽喉科', sections: ['S01','S02','S03','S04'] },
  { id: 'T', name: '整形外科', sections: ['T01','T02','T03','T04','T05','T06','T07'] },
  { id: 'U', name: '精神科', sections: ['U01','U02','U03','U04','U05','U06','U07','U08','U09','U10','U11','U12'] },
  { id: 'V', name: '皮膚科', sections: ['V01','V02','V03','V04','V05','V06','V07','V08','V09'] },
  { id: 'W', name: '泌尿器科', sections: ['W01','W02','W03','W04','W05','W06','W07','W08','W09'] },
  { id: 'X', name: '放射線科', sections: ['X01','X02','X03','X04'] },
];

const MultiLobby = ({ roomInfo, allQuestions, onStart, onLeave }) => {
  const { code, myId, isHost } = roomInfo;
  const [roomData, setRoomData] = useState(null);
  const [selectedGenre, setSelectedGenre] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);

  useEffect(() => {
    const roomRef = ref(db, `multiRooms/${code}`);
    const unsub = onValue(roomRef, snap => {
      const data = snap.val();
      if (!data) return;
      setRoomData(data);
      // ゲーム開始を検知したら onStart を呼ぶ
      if (data.status === 'playing') {
        onStart(data);
      }
    });
    return () => off(roomRef, 'value', unsub);
  }, [code, onStart]);

  const handleStartGame = async () => {
    if (!selectedGenre) return alert('ジャンルを選んでください');
    const genreQuestions = allQuestions[selectedGenre.id];
    if (!genreQuestions) return;

    let filtered = selectedSection === 'ALL'
      ? [...genreQuestions]
      : genreQuestions.filter(q => q.s === selectedSection);

    // シャッフル
    for (let i = filtered.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [filtered[i], filtered[j]] = [filtered[j], filtered[i]];
    }

    await update(ref(db, `multiRooms/${code}`), {
      status: 'playing',
      currentIndex: 0,
      questions: filtered,
      genreId: selectedGenre.id,
      sectionId: selectedSection,
    });
  };

  const players = roomData ? Object.values(roomData.players || {}) : [];

  return (
    <div className="glass-card" style={{ maxWidth: '500px', width: '95%' }}>
      {/* ルームコード */}
      <div style={{
        background: '#ebf5fb', borderRadius: '16px', padding: '16px',
        marginBottom: '20px', width: '100%', boxSizing: 'border-box', textAlign: 'center'
      }}>
        <p style={{ color: '#7f8c8d', fontSize: '0.75rem', margin: '0 0 4px 0', letterSpacing: '0.1em' }}>
          ROOM CODE
        </p>
        <p style={{ color: '#3498db', fontSize: '2.5rem', fontWeight: '900', margin: '0', letterSpacing: '0.3em' }}>
          {code}
        </p>
        <p style={{ color: '#95a5a6', fontSize: '0.75rem', margin: '4px 0 0 0' }}>
          このコードを友達に共有してください
        </p>
      </div>

      {/* 参加者一覧 */}
      <div style={{ width: '100%', marginBottom: '20px' }}>
        <p style={{ color: '#7f8c8d', fontSize: '0.8rem', marginBottom: '8px' }}>
          参加者 {players.length}人
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {players.map((p, i) => (
            <div key={i} style={{
              background: p.isHost ? '#ebf5fb' : '#f8f9fa',
              border: p.isHost ? '2px solid #3498db' : '2px solid #e1e8ed',
              borderRadius: '20px', padding: '6px 14px',
              fontSize: '0.85rem', fontWeight: 'bold',
              color: p.isHost ? '#3498db' : '#2c3e50'
            }}>
              {p.isHost ? '👑 ' : ''}{p.name}
            </div>
          ))}
        </div>
      </div>

      {/* ホストだけジャンル選択を表示 */}
      {isHost && (
        <div style={{ width: '100%', marginBottom: '20px' }}>
          <p style={{ color: '#7f8c8d', fontSize: '0.8rem', marginBottom: '10px' }}>
            ジャンルを選択してスタート
          </p>

          {/* ジャンル一覧 */}
          {!selectedGenre ? (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
              {GENRES_DATA.map(g => (
                <button key={g.id} className="chip-btn"
                  onClick={() => { setSelectedGenre(g); setSelectedSection('ALL'); }}
                  style={{ minWidth: '80px' }}>
                  {g.id} {g.name}
                </button>
              ))}
            </div>
          ) : (
            <div>
              {/* 選択済みジャンル表示 */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                <span style={{ fontWeight: 'bold', color: '#3498db' }}>
                  {selectedGenre.id} {selectedGenre.name}
                </span>
                <button onClick={() => { setSelectedGenre(null); setSelectedSection(null); }}
                  style={{ background: 'none', border: 'none', color: '#95a5a6', cursor: 'pointer', fontSize: '0.8rem' }}>
                  変更
                </button>
              </div>

              {/* セクション選択 */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '16px' }}>
                <button className="chip-btn"
                  onClick={() => setSelectedSection('ALL')}
                  style={{ minWidth: '60px', background: selectedSection === 'ALL' ? '#3498db' : '', color: selectedSection === 'ALL' ? 'white' : '' }}>
                  全部
                </button>
                {selectedGenre.sections.map(sec => (
                  <button key={sec} className="chip-btn"
                    onClick={() => setSelectedSection(sec)}
                    style={{
                      minWidth: '60px',
                      background: selectedSection === sec ? '#3498db' : '',
                      color: selectedSection === sec ? 'white' : ''
                    }}>
                    {sec}
                  </button>
                ))}
              </div>

              <button className="playful-btn" onClick={handleStartGame} style={{ width: '100%' }}>
                ▶ スタート！
              </button>
            </div>
          )}
        </div>
      )}

      {/* 参加者には待機メッセージ */}
      {!isHost && (
        <p style={{ color: '#95a5a6', fontSize: '0.9rem', margin: '10px 0 20px 0' }}>
          ホストがゲームを開始するまで待ってください...
        </p>
      )}

      <button onClick={onLeave}
        style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', fontSize: '0.85rem' }}>
        ルームを退出する
      </button>
    </div>
  );
};

export default MultiLobby;